type ReleaseData = {
  date: Date;
  version: string;
  notes: string;
};

export const getLastRelease = () => releases[0];
export const getVersion = () => getLastRelease()?.version || 'unknown';

const releases: Array<ReleaseData> = [
  {
    version: '1.91.1',
    date: new Date('2025-11-19'),
    notes:
      'Offer publishing enabled only for admins (super admins) and moderators (admins)',
  },
  {
    version: '1.91.0',
    date: new Date('2025-11-19'),
    notes:
      'Release remaining functionality for Offers phase 3. Offer publishing enabled only for admins',
  },
  {
    version: '1.90.6',
    date: new Date('2025-11-17'),
    notes:
      'Offer price validation, filter tabs order change, extras label update',
  },
  {
    version: '1.90.5',
    date: new Date('2025-11-12'),
    notes: 'Remove coaching & services links ',
  },
  {
    version: '1.90.4',
    date: new Date('2025-11-12'),
    notes: 'Fix testimonials section validation bug',
  },
  {
    version: '1.90.3',
    date: new Date('2025-11-11'),
    notes:
      'Fix missing transaction ledger export button and missing OTP payouts paidAt date',
  },
  {
    version: '1.90.2',
    date: new Date('2025-11-07'),
    notes: 'Video re-upload bug fixed',
  },
  {
    version: '1.90.1',
    date: new Date('2025-11-07'),
    notes:
      'Clarify Extras subscription messaging, Fix offer form dropdown list for safari',
  },
  {
    version: '1.90.0',
    date: new Date('2025-11-06'),
    notes: 'Enable OTP offers for all creators',
  },
  {
    version: '1.89.9',
    date: new Date('2025-10-22'),
    notes: 'Show Black Friday Challenge to all creators',
  },
  {
    version: '1.89.8',
    date: new Date('2025-10-22'),
    notes: 'Home screen improvements & black friday challenge launch',
  },
  {
    version: '1.89.7',
    date: new Date('2025-10-13'),
    notes: 'Extras: batch of improvements',
  },
  {
    version: '1.89.6',
    date: new Date('2025-10-09'),
    notes: 'Videos general availability',
  },
  {
    version: '1.89.5',
    date: new Date('2025-10-08'),
    notes: 'Improvements for videos and comments',
  },
  {
    version: '1.89.4',
    date: new Date('2025-10-01'),
    notes: 'minor webhooks update',
  },
  {
    version: '1.89.3',
    date: new Date('2025-09-30'),
    notes: 'admins/superadmins videos release',
  },
  {
    version: '1.89.2',
    date: new Date('2025-09-29'),
    notes: 'rename UpdateSubscriptionBundleInput to UpdateBundleInput',
  },
  {
    version: '1.89.1',
    date: new Date('2025-09-26'),
    notes:
      'handle optional tags in useLibraryModel for improved error handling',
  },
  {
    version: '1.89.0',
    date: new Date('2025-09-25'),
    notes: 'Video Content Type & comments',
  },
  {
    version: '1.88.1',
    date: new Date('2025-09-16'),
    notes: 'Add bundle feature validation for select',
  },
  {
    version: '1.88.0',
    date: new Date('2025-09-11'),
    notes: 'Bundle builder phase 2 - bundle content management',
  },
  {
    version: '1.87.2',
    date: new Date('2025-09-08'),
    notes: 'Extras slides improvement',
  },
  {
    version: '1.87.1',
    date: new Date('2025-08-28'),
    notes: 'Extras general availability',
  },
  {
    version: '1.87.0',
    date: new Date('2025-08-28'),
    notes: 'Extras PDF/Slides improvements before release. Live UI',
  },
  {
    version: '1.86.5',
    date: new Date('2025-08-19'),
    notes: 'Minor UI improvements and bug fixes for Extras feature',
  },
  {
    version: '1.86.4',
    date: new Date('2025-08-19'),
    notes: 'PDF Extras release',
  },
  {
    version: '1.86.3',
    date: new Date('2025-08-13'),
    notes: 'Fix connect stripe',
  },
  {
    version: '1.86.2',
    date: new Date('2025-08-11'),
    notes: 'Fix for creating empty slides',
  },
  {
    version: '1.86.1',
    date: new Date('2025-08-11'),
    notes: 'Fix missing correct state in extras reordering',
  },
  {
    version: '1.86.0',
    date: new Date('2025-08-11'),
    notes: 'Image Slides support in extras',
  },
  {
    version: '1.85.6',
    date: new Date('2025-07-23'),
    notes: 'Business model filter on creators list for admins',
  },
  {
    version: '1.85.5',
    date: new Date('2025-07-23'),
    notes: 'Fix GetCrmData graphql',
  },
  {
    version: '1.85.4',
    date: new Date('2025-07-22'),
    notes: 'Fix ExtrasItem description overflow, add missing styles',
  },
  {
    version: '1.85.3',
    date: new Date('2025-07-17'),
    notes: 'Fix input number precision',
  },
  {
    version: '1.85.2',
    date: new Date('2025-07-17'),
    notes: 'Tabata components into DS, fix for tabata exercise set',
  },
  {
    version: '1.85.1',
    date: new Date('2025-07-16'),
    notes: 'Minor extras validation tweak',
  },
  {
    version: '1.85.0',
    date: new Date('2025-07-15'),
    notes: 'Fix logic that controls display of the transaction ledger export',
  },
  {
    version: '1.84.1',
    date: new Date('2025-07-15'),
    notes: 'Cleanup insights',
  },
  {
    version: '1.84.0',
    date: new Date('2025-07-15'),
    notes: 'Self-serve extras',
  },
  {
    version: '1.83.0',
    date: new Date('2025-07-14'),
    notes: 'Support bundles',
  },
  {
    version: '1.82.3',
    date: new Date('2025-07-09'),
    notes: 'Exercise Library prompt',
  },
  {
    version: '1.82.2',
    date: new Date('2025-07-08'),
    notes: 'Super Tooltips improvements & homepage tweaks',
  },
  {
    version: '1.82.1',
    date: new Date('2025-07-07'),
    notes: 'Running template improvements & bugfix pack',
  },
  {
    version: '1.82.0',
    date: new Date('2025-07-03'),
    notes: 'Program upload feature',
  },
  {
    version: '1.81.2',
    date: new Date('2025-07-02'),
    notes: 'Running education tooltip & tracking',
  },
  {
    version: '1.81.1',
    date: new Date('2025-07-01'),
    notes: 'Releasing running',
  },
  {
    version: '1.81.0',
    date: new Date('2025-06-25'),
    notes: 'Running feature flag reintroduction',
  },
  {
    version: '1.80.3',
    date: new Date('2025-06-23'),
    notes: 'Enable transactions export on integration',
  },
  {
    version: '1.80.2',
    date: new Date('2025-06-23'),
    notes: 'Workout set render fix',
  },
  {
    version: '1.80.1',
    date: new Date('2025-06-18'),
    notes: 'Running/treadmill template - fix',
  },
  {
    version: '1.80.0',
    date: new Date('2025-06-13'),
    notes: 'Running/treadmill template',
  },
  {
    version: '1.79.0',
    date: new Date('2025-06-06'),
    notes: 'Running for all creators',
  },
  {
    version: '1.78.2',
    date: new Date('2025-06-16'),
    notes: 'Fix dm page loading state when feature is disabled',
  },
  {
    version: '1.78.1',
    date: new Date('2025-06-13'),
    notes: 'Enable non-admin export of the transactions ledger',
  },
  {
    version: '1.78.0',
    date: new Date('2025-06-11'),
    notes: 'Add transactions export for payouts',
  },
  {
    version: '1.77.5',
    date: new Date('2025-06-10'),
    notes: 'Display recommendations to every creator',
  },
  {
    version: '1.77.4',
    date: new Date('2025-06-06'),
    notes: 'Hide subscription gift link for exclusive creators',
  },
  {
    version: '1.77.3',
    date: new Date('2025-06-05'),
    notes: 'Fix for storybook tests after react package bump',
  },
  {
    version: '1.77.2',
    date: new Date('2025-05-27'),
    notes:
      'Set unread messages bold on dm chat and fix reply with dm redirect on workout comment',
  },
  {
    version: '1.77.1',
    date: new Date('2025-05-22'),
    notes: 'Inline img tags parsing for super tooltips',
  },
  {
    version: '1.77.0',
    date: new Date('2025-05-22'),
    notes: 'Super tooltips, hubspot integration',
  },
  {
    version: '1.76.0',
    date: new Date('2025-05-20'),
    notes: 'React package bump to version 18 and code cleanup',
  },
  {
    version: '1.75.2',
    date: new Date('2025-05-08'),
    notes: 'Navigation menu mixpanel event',
  },
  {
    version: '1.75.1',
    date: new Date('2025-05-07'),
    notes: 'New homepage events: change event names',
  },
  {
    version: '1.75.0',
    date: new Date('2025-05-06'),
    notes: 'New homepage design',
  },
  {
    version: '1.74.5',
    date: new Date('2025-04-29'),
    notes: 'Remove autoplayedWorkouts feature flag',
  },
  {
    version: '1.74.4',
    date: new Date('2025-04-24'),
    notes: 'CRM UI fixes',
  },
  {
    version: '1.74.3',
    date: new Date('2025-04-24'),
    notes: 'Tabata/HIIT workout builder improvements',
  },
  {
    version: '1.74.2',
    date: new Date('2025-04-15'),
    notes: 'Add videos in processing state to Video Library',
  },
  {
    version: '1.74.1',
    date: new Date('2025-04-14'),
    notes: 'Fix for workout builder - circuit exercise type',
  },
  {
    version: '1.74.0',
    date: new Date('2025-04-14'),
    notes: 'Tabata/Hiit workout builder',
  },
  {
    version: '1.73.2',
    date: new Date('2025-04-14'),
    notes: 'Remove ppcConversionReqested from customizations',
  },
  {
    version: '1.73.1',
    date: new Date('2025-04-10'),
    notes: 'Mixpanel parser, sort archived workouts by date',
  },
  {
    version: '1.73.0',
    date: new Date('2025-04-10'),
    notes: 'Subscription price modal layout update, Self serve ppc e2e',
  },
  {
    version: '1.72.7',
    date: new Date('2025-04-08'),
    notes: 'Fix save subscription price on home modal for creator',
  },
  {
    version: '1.72.6',
    date: new Date('2025-04-04'),
    notes: 'Livestream article url update and avatar source update',
  },
  {
    version: '1.72.5',
    date: new Date('2025-04-02'),
    notes: 'Image handler url moved to env',
  },
  {
    version: '1.72.4',
    date: new Date('2025-04-01'),
    notes: 'Community post layout update, Self serve ppc price errors updates',
  },
  {
    version: '1.72.3',
    date: new Date('2025-03-31'),
    notes: 'Community redirect',
  },
  {
    version: '1.72.2',
    date: new Date('2025-03-31'),
    notes: 'Library upload validation for landscape videos',
  },
  {
    version: '1.72.1',
    date: new Date('2025-03-29'),
    notes: 'Fix for subscription price alert',
  },
  {
    version: '1.72.0',
    date: new Date('2025-03-28'),
    notes: 'Updates for self serve exclusive subscription',
  },
  {
    version: '1.71.0',
    date: new Date('2025-03-17'),
    notes: 'Self serve exclusive subscription',
  },
  {
    version: '1.70.3',
    date: new Date('2025-02-26'),
    notes: 'Add from library layout fixes, Library filters label fix',
  },
  {
    version: '1.70.2',
    date: new Date('2025-02-25'),
    notes:
      'Show share modal for all programs, but add disclaimer to non-published ones',
  },
  {
    version: '1.70.1',
    date: new Date('2025-02-21'),
    notes:
      'Fix chat layout with long users list, fix missing avatar on livestream',
  },
  {
    version: '1.70.0',
    date: new Date('2025-02-20'),
    notes: 'Allow creators to DM users on web who leave workout comments',
  },
  {
    version: '1.69.2',
    date: new Date('2025-02-17'),
    notes: 'Links cleanup',
  },
  {
    version: '1.69.1',
    date: new Date('2025-02-11'),
    notes: 'Filtering discount details by name, email, type',
  },
  {
    version: '1.69.0',
    date: new Date('2025-02-10'),
    notes: 'Challenges enabled for everyone',
  },
  {
    version: '1.68.2',
    date: new Date('2025-02-05'),
    notes:
      'Update workouts page view stats to begins, profile page name validation to not allow empty string, fix redirect to edit workout',
  },
  {
    version: '1.68.1',
    date: new Date('2025-02-05'),
    notes: 'Challenges table hover effect and responsive table',
  },
  {
    version: '1.68.0',
    date: new Date('2025-02-05'),
    notes:
      'Add email address copy to community post menu, Library fix select all folders',
  },
  {
    version: '1.67.2',
    date: new Date('2025-02-04'),
    notes: 'Program duplication',
  },
  {
    version: '1.67.1',
    date: new Date('2025-02-04'),
    notes: 'Track table menu item events in sentry',
  },
  {
    version: '1.67.0',
    date: new Date('2025-02-04'),
    notes: 'Set ppc only flag in customizations.',
  },
  {
    version: '1.66.2',
    date: new Date('2025-01-27'),
    notes: 'Enable transformation media for Challenges. Updated form copy.',
  },
  {
    version: '1.66.1',
    date: new Date('2025-01-23'),
    notes: 'Fix admin menu - enable promotions and marketing',
  },
  {
    version: '1.66.0',
    date: new Date('2025-01-22'),
    notes: 'New onboarding flow with go live button and educational modals',
  },
  {
    version: '1.65.0',
    date: new Date('2025-01-20'),
    notes:
      'Improvements to challenges submission view, support for multiple challenges.',
  },
  {
    version: '1.64.10',
    date: new Date('2025-01-17'),
    notes:
      'Login confirmation code - show numeric keyboard for input, Create user validation for space char in name, Settings page text copy update',
  },
  {
    version: '1.64.9',
    date: new Date('2025-01-16'),
    notes: 'Administration update Searchable payload fix',
  },
  {
    version: '1.64.8',
    date: new Date('2025-01-16'),
    notes:
      'Allow schedule workout only in future date, OTP set price paylod fix',
  },
  {
    version: '1.64.7',
    date: new Date('2025-01-13'),
    notes: 'Fix getting user role for not-logged-in users',
  },
  {
    version: '1.64.6',
    date: new Date('2025-01-10'),
    notes: 'Allow all admins & moderators to manage challenges',
  },
  {
    version: '1.64.5',
    date: new Date('2025-01-10'),
    notes: 'Fix week & date selection while editing workout',
  },
  {
    version: '1.64.4',
    date: new Date('2025-01-10'),
    notes:
      'Program target area selection fix, Circuit select multiple videos from library',
  },
  {
    version: '1.64.3',
    date: new Date('2025-01-09'),
    notes: 'Week/Day fix for workout title',
  },
  {
    version: '1.64.2',
    date: new Date('2025-01-03'),
    notes: 'Challenges builder UI fixes',
  },
  {
    version: '1.64.0',
    date: new Date('2025-01-03'),
    notes: 'Challenges builder & submissions management panel',
  },
  {
    version: '1.63.0',
    date: new Date('2024-12-20'),
    notes:
      'Workout builder remove equipment, Add from library modal height change',
  },
  {
    version: '1.62.7',
    date: new Date('2024-12-18'),
    notes: 'Workout builder circuit exercise fix, Library layout fixes',
  },
  {
    version: '1.62.6',
    date: new Date('2024-12-18'),
    notes:
      'Workout builder upload creates new template fix, Exercise set default value set to reps',
  },
  {
    version: '1.62.5',
    date: new Date('2024-12-16'),
    notes: 'Library download fix, LP builder add program carousel fix',
  },
  {
    version: '1.62.4',
    date: new Date('2024-12-13'),
    notes: 'Fix for otp workout list edit action',
  },
  {
    version: '1.62.3',
    date: new Date('2024-12-11'),
    notes: 'Workout builder fix circuit exercise add from library',
  },
  {
    version: '1.62.2',
    date: new Date('2024-12-10'),
    notes: 'Workout builder fix circuit media',
  },
  {
    version: '1.62.1',
    date: new Date('2024-12-05'),
    notes: 'Discount details - feature flag removed',
  },
  {
    version: '1.62.0',
    date: new Date('2024-12-09'),
    notes: 'Workout builder ui updates',
  },
  {
    version: '1.61.0',
    date: new Date('2024-12-05'),
    notes:
      'Library added global search context, Workout builder added folders and global search context to add from library modals',
  },
  {
    version: '1.60.1',
    date: new Date('2024-12-04'),
    notes: 'Fix for link to OTP discount checkout page',
  },
  {
    version: '1.60.0',
    date: new Date('2024-12-04'),
    notes: 'Discount details page, changes on discounts table',
  },
  {
    version: '1.59.2',
    date: new Date('2024-12-04'),
    notes:
      'Increase char limit of profile page story, hide archived collection lp link, fix edit otp media',
  },
  {
    version: '1.59.1',
    date: new Date('2024-11-28'),
    notes: 'Hide gift page link for ppc creators',
  },
  {
    version: '1.59.0',
    date: new Date('2024-11-25'),
    notes:
      `Dev Update: changes to Circle CI and assets source resolution to work ` +
      `better on preview branches. This release is transparent to production ` +
      `environment.`,
  },
  {
    version: '1.58.1',
    date: new Date('2024-11-22'),
    notes: 'Extend max text length in LP builder to 1300 chars.',
  },
  {
    version: '1.58.0',
    date: new Date('2024-11-18'),
    notes:
      'Program edit for creator, creators list filters updated, otp only creator changes',
  },
  {
    version: '1.57.3',
    date: new Date('2024-11-15'),
    notes: 'Fixed workout redirect to comments page for admin',
  },
  {
    version: '1.57.2',
    date: new Date('2024-11-08'),
    notes: 'Sentry session tracking improved (part 2)',
  },
  {
    version: '1.57.1',
    date: new Date('2024-11-08'),
    notes: 'Sentry session tracking improved',
  },
  {
    version: '1.57.0',
    date: new Date('2024-11-07'),
    notes: 'Session tracking',
  },
  {
    version: '1.56.1',
    date: new Date('2024-11-04'),
    notes: 'OTP Discount error handling for missing pricing',
  },
  {
    version: '1.56.0',
    date: new Date('2024-10-28'),
    notes: 'Editing content fixes',
  },
  {
    version: '1.55.0',
    date: new Date('2024-10-25'),
    notes: 'Discounts filtering + fix program category form issues',
  },
  {
    version: '1.54.4',
    date: new Date('2024-10-22'),
    notes: 'Fix OTP Landing Page builder issues',
  },
  {
    version: '1.54.3',
    date: new Date('2024-10-18'),
    notes: 'Fix OTP Landing Page builder issues',
  },
  {
    version: '1.54.2',
    date: new Date('2024-10-18'),
    notes: 'Fix OTP discounts value transformer',
  },
  {
    version: '1.54.1',
    date: new Date('2024-10-10'),
    notes: 'OTP Discounts improvements',
  },
  {
    version: '1.54.0',
    date: new Date('2024-10-10'),
    notes: 'OTP Discounts support',
  },
  {
    version: '1.53.0',
    date: new Date('2024-10-04'),
    notes: 'OTP LP builder fixes',
  },
  {
    version: '1.52.1',
    date: new Date('2024-10-03'),
    notes:
      'Enabled promos for all creators, fixes and improvements related to promotions',
  },
  {
    version: '1.52.0',
    date: new Date('2024-09-27'),
    notes: 'Library folders',
  },
  {
    version: '1.51.3',
    date: new Date('2024-09-27'),
    notes: 'Promotions feature layout fixes',
  },
  {
    version: '1.51.2',
    date: new Date('2024-09-24'),
    notes: 'Promotions feature layout fixes',
  },
  {
    version: '1.51.1',
    date: new Date('2024-09-23'),
    notes: 'Promotions feature fixes',
  },
  {
    version: '1.51.0',
    date: new Date('2024-09-23'),
    notes: 'Promotions feature support',
  },
  {
    version: '1.50.0',
    date: new Date('2024-09-16'),
    notes: 'Fixed bugs related to program publishing validation.',
  },
  {
    version: '1.49.0',
    date: new Date('2024-09-09'),
    notes:
      'Home Page case studies, Profile page updates, LP header, publish modal collapsable links, library srot/filter and gallery view, switch live conditions',
  },
  {
    version: '1.48.0',
    date: new Date('2024-09-02'),
    notes: `Sends message type in payload when resubscribing`,
  },
  {
    version: '1.47.0',
    date: new Date('2024-08-26'),
    notes: `Adds creator's mail subscripition page`,
  },
  {
    version: '1.46.0',
    date: new Date('2024-08-08'),
    notes: 'Home Page Upgrades, Emai capture form',
  },
  {
    version: '1.45.0',
    date: new Date('2024-08-01'),
    notes: `Use creator's payment method for transfer fee label in payouts dashboard`,
  },
  {
    version: '1.44.1',
    date: new Date('2024-07-11'),
    notes: 'Fix OTP price for decimal number',
  },
  {
    version: '1.44.0',
    date: new Date('2024-07-10'),
    notes:
      'Instagram input validation, Tags readonly state, Publish archived workout',
  },
  {
    version: '1.43.0',
    date: new Date('2024-07-09'),
    notes: 'DM input length',
  },
  {
    version: '1.42.0',
    date: new Date('2024-07-04'),
    notes:
      'OTP upgrades, Disable community toggle for OTP only creators, Add sales page tab to subscription programs, Intercom',
  },
  {
    version: '1.41.1',
    date: new Date('2024-07-02'),
    notes:
      'Meta Pixel tracking support, Unpubilish workout, Megred library backward compatibility, Workout Builder Circuit exercise fix, Payouts Dashboard, CRM data fixes and additional columns',
  },
  {
    version: '1.41.0',
    date: new Date('2024-06-18'),
    notes:
      'Workout builder cache fix, media upload file extension removed, increase bio char limit in LP',
  },
  {
    version: '1.40.0',
    date: new Date('2024-06-17'),
    notes:
      'Workout builder copy set unit, workout builder redirect on save and publish, fix toCollectionURL',
  },
  {
    version: '1.39.0',
    date: new Date('2024-06-12'),
    notes:
      'Workout builder library templates, Schedule workout only with collection, Builder single uload wait for processing finished, Add Duration in exercise template, Rename exclusives, Disable compression for HeroFullImage',
  },
  {
    version: '1.38.0',
    date: new Date('2024-05-29'),
    notes: 'Merged Library fixes, PPC price limit change',
  },
  {
    version: '1.37.0',
    date: new Date('2024-05-28'),
    notes: 'Merged Library',
  },
  {
    version: '1.36.0',
    date: new Date('2024-05-21'),
    notes: 'Pre release Merged Library Banner',
  },
  {
    version: '1.35.2',
    date: new Date('2024-05-07'),
    notes: 'Bug fixes',
  },
  {
    version: '1.35.1',
    date: new Date('2024-04-30'),
    notes: 'Bug fixes',
  },
  {
    version: '1.35.0',
    date: new Date('2024-04-24'),
    notes:
      'Creator homepage for Admins, moderator hide links, add crator error message',
  },
  {
    version: '1.34.0',
    date: new Date('2024-04-17'),
    notes: 'Tier label update, mixpanel event',
  },
  {
    version: '1.33.2',
    date: new Date('2024-03-22'),
    notes: 'Unreachable webhook tab - bug fixed',
  },
  {
    version: '1.33.1',
    date: new Date('2024-03-18'),
    notes: 'Campaign setup link adjustment',
  },
  {
    version: '1.33.0',
    date: new Date('2024-03-18'),
    notes:
      'Upload short video to mux, update filter and sort on admin dashaboard',
  },
  {
    version: '1.32.1',
    date: new Date('2024-03-14'),
    notes: 'MixPanel tracking fix',
  },
  {
    version: '1.32.0',
    date: new Date('2024-03-14'),
    notes: 'MixPanel integration',
  },
  {
    version: '1.31.0',
    date: new Date('2024-03-11'),
    notes:
      'Admin settings page update, edit tier on dashboard, community state fix, add customizations to administration, fix for yt link, insights reorder and creators list',
  },
  {
    version: '1.30.0',
    date: new Date('2024-03-04'),
    notes: 'Insights reorder, fix for DM token and enable state for creator',
  },
  {
    version: '1.29.0',
    date: new Date('2024-02-28'),
    notes: 'Marketing UI/UX improvements',
  },
  {
    version: '1.28.0',
    date: new Date('2024-02-28'),
    notes:
      'Add new creator, creator list stats, fix for custom url update by admin',
  },
  {
    version: '1.27.0',
    date: new Date('2024-02-23'),
    notes: 'Custom domain setup on OTP landing page',
  },
  {
    version: '1.26.0',
    date: new Date('2024-02-14'),
    notes: 'Marketing pages tuned up',
  },
  {
    version: '1.25.0',
    date: new Date('2024-02-02'),
    notes:
      'TikTok and Google Services support in Marketing > Integrations section',
  },
  {
    version: '1.24.0',
    date: new Date('2024-02-01'),
    notes:
      'Admin dashboard, subscription type filter added, filter keep state on navigation',
  },
  {
    version: '1.23.2',
    date: new Date('2024-01-30'),
    notes:
      'Fix analytics data in creator context page, workout default timezone update',
  },
  {
    version: '1.23.1',
    date: new Date('2024-01-26'),
    notes: 'Fix for admin menu edit collections & programs',
  },
  {
    version: '1.23.0',
    date: new Date('2024-01-26'),
    notes: 'New Admin menu with creator context',
  },
  {
    version: '1.22.1',
    date: new Date('2024-01-16'),
    notes: 'Marketing pages fixes',
  },
  {
    version: '1.22.0',
    date: new Date('2024-01-15'),
    notes: '7 day free trial, PPC annual fee, CRM menu link for moderators',
  },
  {
    version: '1.21.1',
    date: new Date('2024-01-11'),
    notes: 'Marketing > analytics dashboards fixes',
  },
  {
    version: '1.21.0',
    date: new Date('2023-12-27'),
    notes: 'Added marketing>analytics dashboards',
  },
  {
    version: '1.20.0',
    date: new Date('2023-12-21'),
    notes:
      'Added marketing page with separate integrations and URL builder sections',
  },
  {
    version: '1.19.0',
    date: new Date('2023-12-19'),
    notes:
      'Convert OTP creators to PPC, CRM purchase and export display updates, video bugfixes',
  },
  {
    version: '1.18.0',
    date: new Date('2023-12-12'),
    notes: 'Convert creator to PPC, Payout Rules for admins',
  },
  {
    version: '1.17.1',
    date: new Date('2023-12-01'),
    notes: 'Fix for video upload validation on single exercise upload',
  },
  {
    version: '1.17.0',
    date: new Date('2023-11-23'),
    notes: 'New Ad tracking page with meta pixel form and URL creator',
  },
  {
    version: '1.16.0',
    date: new Date('2023-11-22'),
    notes:
      'added modal with thumbnail selection on single exercise video upload, fix for community media upload',
  },
  {
    version: '1.15.0',
    date: new Date('2023-11-09'),
    notes:
      'trim short videos on upload for admin, adjusted video upload limit size to 100MB',
  },
  {
    version: '1.14.1',
    date: new Date('2023-11-08'),
    notes: 'fix for Add New Partner in admin dashboard view',
  },
  {
    version: '1.14.0',
    date: new Date('2023-11-06'),
    notes: 'CRM full release (every creator) + new webhook triggers',
  },
  {
    version: '1.13.1',
    date: new Date('2023-11-02'),
    notes: 'Hide new webhook options yet again',
  },
  {
    version: '1.13.0',
    date: new Date('2023-11-02'),
    notes: 'CRM soft release',
  },
  {
    version: '1.12.8',
    date: new Date('2023-10-31'),
    notes: 'Category edit hotfix',
  },
  {
    version: '1.12.7',
    date: new Date('2023-10-25'),
    notes: 'GA4 fixes',
  },
  {
    version: '1.12.6',
    date: new Date('2023-10-23'),
    notes:
      'Display error when stripe is connected, but it is not set as a payment method',
  },
  {
    version: '1.12.5',
    date: new Date('2023-10-17'),
    notes:
      'Admin can upload videos for creator. Bug fix: show video length on new video library page',
  },
  {
    version: '1.12.4',
    date: new Date('2023-10-10'),
    notes:
      'bug fixes: Token expired & invalid video id + fix copy in breadcrumbs ',
  },
  {
    version: '1.12.3',
    date: new Date('2023-10-06'),
    notes: 'Fix for exercise video upload',
  },
  {
    version: '1.12.2',
    date: new Date('2023-10-06'),
    notes: 'Unpublish flow fixed for categories',
  },
  {
    version: '1.12.1',
    date: new Date('2023-10-03'),
    notes: 'Corrected spelling "Analize purchases -> Analyze purchases"',
  },
  {
    version: '1.12.0',
    date: new Date('2023-10-02'),
    notes:
      'Admin can now change video name, mute and change thumbnail. Exercise can be created from video. New video picker while creating exercise.',
  },
  {
    version: '1.11.1',
    date: new Date('2023-10-02'),
    notes: 'Fix for creating new program with correct sales type',
  },
  {
    version: '1.11.0',
    date: new Date('2023-09-29'),
    notes: 'Added video upload for new videos module',
  },
  {
    version: '1.10.3',
    date: new Date('2023-09-29'),
    notes: 'Fix for keywords checks on profile page',
  },
  {
    version: '1.10.2',
    date: new Date('2023-09-25'),
    notes: 'Fix for publishing unpublished programs by creators',
  },
  {
    version: '1.10.1',
    date: new Date('2023-09-21'),
    notes: 'Fix publishing invalid OTPs, fixed new collection page titles',
  },
  {
    version: '1.10.0',
    date: new Date('2023-09-21'),
    notes: 'Navbar fix',
  },
  {
    version: '1.9.4',
    date: new Date('2023-09-08'),
    notes: 'Domain form validation improvements',
  },
  {
    version: '1.9.3',
    date: new Date('2023-09-07'),
    notes:
      "metabase dashboards update + security fix - don't set default user password",
  },
  {
    version: '1.9.2',
    date: new Date('2023-09-01'),
    notes:
      'program/workouts management edit archived subscription fix, menu active on all pages, breadcrumb added to workouts edit pages, updated go back with parent location',
  },
  {
    version: '1.9.1',
    date: new Date('2023-09-01'),
    notes: 'program/workouts management subscription actions fix',
  },
  {
    version: '1.9.0',
    date: new Date('2023-08-29'),
    notes: 'program/workouts management + sign-up flow update',
  },
  {
    version: '1.8.0',
    date: new Date('2023-08-02'),
    notes: 'ga4',
  },
  {
    version: '1.7.0',
    date: new Date('2023-07-26'),
    notes: 'onboarding self service',
  },
];
